import React, { Component } from 'react';
import InputText from '../blueprintWrappers/InputText';

class LeadSearch extends Component {

	render() {
		return (
			<div>
				<InputText
					onChange={this._onChange}
					placeholder='Search'
					value={this.props.searchText}
				/>
			</div>
		);
	}

	_onChange = (e) => {
		this.props.searchOnChange(e);
	}
}
export default LeadSearch;


// WEBPACK FOOTER //
// ./src/components/leadtracker/LeadSearch.js